import Enum from '/@/modules/core/app/helpers/Enum';
import Lang from '/@/modules/core/app/services/Lang';

export class EstateTaskProfessionStatus extends Enum {
  key!: string;
  value!: string;
  color!: string;
  order!: number;

  static NEW: EstateTaskProfessionStatus = {
    key: 'new',
    get value(): string {
      return Lang.t('estate.new');
    },
    color: '#9846EA',
    order: 100
  };

  static ONGOING: EstateTaskProfessionStatus = {
    key: 'in_progress',
    get value(): string {
      return Lang.t('estate.in-progress');
    },
    color: '#f0932b',
    order: 200
  };

  static COMPLETED: EstateTaskProfessionStatus = {
    key: 'completed',
    get value(): string {
      return Lang.t('estate.closed-completed');
    },
    color: '#60C49D',
    order: 300
  };

  static COMPLETE_OC: EstateTaskProfessionStatus = {
    key: 'complete_oc',
    get value(): string {
      return Lang.t('estate.complete');
    },
    color: '#60C49D',
    order: 400
  };

  static getCompletedStatus(): string[] {
    return [EstateTaskProfessionStatus.COMPLETED.key, EstateTaskProfessionStatus.COMPLETE_OC.key];
  }

  static isCompletedStatus(status: string): boolean {
    return EstateTaskProfessionStatus.getCompletedStatus().includes(status);
  }
}
